(ns manage.poi.labels.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-query]]
            [common.resource.query.poi :as poi.q]
            [manage.poi.shared :refer [delete-action-column]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- label-columns [on-delete]
  #js [#js {:field "name"
            :headerName "Label"
            :flex 2
            :valueGetter (fn [_ row] (:name row))
            :renderCell (fn [^js param]
                          ($ :div
                             (let [label (->clj (.-value param))]
                               ($ Chip {:key label
                                        :label label
                                        :size "small"
                                        :sx #js {:backgroundColor "#e0e0e0"
                                                 :color "#212121"}}))))}
       #js {:field "locations"
            :headerName "Locations"
            :flex 1
            :type "number"
            :valueGetter (fn [_ row] (:locations row))}
       #js {:field "selectors"
            :headerName "Selectors"
            :flex 1
            :type "number"
            :valueGetter (fn [_ row] (:selectors row))}
       (delete-action-column on-delete
                             (fn [row] {:label-name (:name row)
                                        :locations (:locations row)
                                        :selectors (:selectors row)}))])

(defn- get-label-id [row]
  (:name row))

(defui labels []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {dataset-ready :isSuccess} (use-query (poi.q/ensure-dataset {:advertiser-id advertiser-id}))
        {labels-data :data isPending :isPending}
        (use-query (poi.q/labels-query {:advertiser-id advertiser-id
                                        :enabled? dataset-ready}))]
    ($ :<>
       ($ Stack {:direction "row" :justifyContent "flex-end" :p 1}
          ($ Button {:variant "contained"
                     :onClick #(rf/dispatch [:ocp/open {:id :poi/create-label}])}
             "+ New Label"))
       ($ DataGridPremium
          {:columns (label-columns (fn [props]
                                     (rf/dispatch [:modal/open {:id :poi/confirm-delete-label
                                                                :props props}])))
           :loading isPending
           :rows (to-array (or labels-data []))
           :getRowId get-label-id
           :onRowClick (fn [^js params]
                         (rf/dispatch [:ocp/open {:id :poi/label
                                                  :props {:label (->clj (.-row params))}}]))
           :disableRowSelectionOnClick true
           :disableColumnFilter true
           :hideFooter true
           :localeText #js {:noRowsLabel "No labels found"}
           :initialState #js {:sorting #js {:sortModel #js [#js {:field "name" :sort "asc"}]}}
           :sx #js {:maxHeight "70rem"}}))))
